var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTelegram = function SvgTelegram(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#telegram_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M22 11c0 6.075-4.925 11-11 11S0 17.075 0 11 4.925 0 11 0s11 4.925 11 11M11.394 8.12Q9.79 8.79 4.98 10.885q-.78.31-.818.608c-.042.334.377.466.948.646l.24.076c.562.183 1.318.396 1.71.405q.535.011 1.193-.44 4.495-3.035 4.64-3.068c.069-.015.164-.035.228.023.064.057.058.165.051.194-.041.177-1.687 1.707-2.538 2.499-.266.246-.454.422-.493.462q-.13.134-.258.255c-.522.503-.913.88.021 1.496.45.296.809.541 1.167.785.392.267.783.533 1.288.864q.193.128.372.258c.455.325.865.617 1.37.57.295-.027.598-.303.752-1.128.365-1.948 1.081-6.169 1.247-7.908a2 2 0 0 0-.019-.433.46.46 0 0 0-.156-.298c-.132-.107-.335-.13-.426-.128-.414.007-1.049.228-4.104 1.499",
    clipRule: "evenodd"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "telegram_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h22v22H0z"
  })))));
};
export default SvgTelegram;